import * as React from 'react';
import { Button } from '@cian/ui-kit';
import { handleDynamicCalltracking, EPageTypes, EPlatformTypes } from '@cian/frontend-newbuilding-call-component';

import { useApplicationContext } from '../../utils/applicationContext';

export interface ICallBuilderProps {
  phone: string;
  placeType?: string;
  siteBlockId?: number | null;
  trackAction(): void;
}

export const CallBuilder: React.VFC<ICallBuilderProps> = ({
  phone,
  placeType = 'CallBuilder',
  siteBlockId,
  trackAction,
}) => {
  const { httpApi, logger } = useApplicationContext();

  const handleClick = React.useCallback(async () => {
    let dynamicPhone = null;

    if (siteBlockId) {
      const response = await handleDynamicCalltracking({
        logger,
        httpApi,
        blockId: siteBlockId,
        platformType: EPlatformTypes.WebMobile,
        pageType: EPageTypes.NewbuildingCard,
        placeType,
      });

      dynamicPhone = response.notFormattedPhone ? `+${response.notFormattedPhone}` : response.notFormattedPhone;
    }

    trackAction();

    const tel = dynamicPhone || phone;
    window.location.href = `tel:${tel}`;
  }, [httpApi, logger, phone, placeType, siteBlockId, trackAction]);

  return (
    <Button fullWidth size="L" onClick={handleClick}>
      Позвонить
    </Button>
  );
};
